// | Integration of the cart with JS world.
import * as $runtime from "../runtime.js";
import * as Control$dMonad$dReader$dTrans from "../Control.Monad.Reader.Trans/index.js";
import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dDateTime$dInstant from "../Data.DateTime.Instant/index.js";
import * as Data$dEither$dExtra from "../Data.Either.Extra/index.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dIdentity from "../Data.Identity/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dMoney$dRounded from "../Data.Money.Rounded/index.js";
import * as Data$dNullable from "../Data.Nullable/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dRecord from "../Data.Record/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dString$dCommon from "../Data.String.Common/index.js";
import * as Data$dTime$dLocal from "../Data.Time.Local/index.js";
import * as Data$dTraversable from "../Data.Traversable/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Data$dUUID from "../Data.UUID/index.js";
import * as Effect$dClass from "../Effect.Class/index.js";
import * as Effect$dConsole from "../Effect.Console/index.js";
import * as Effect$dNow from "../Effect.Now/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Foreign$dInternal$dStringify from "../Foreign.Internal.Stringify/index.js";
import * as Foreign$dNullOrUndefined from "../Foreign.NullOrUndefined/index.js";
import * as Raven from "../Raven/index.js";
import * as Restaumatic$dAnalytics$dTypes$dItemList from "../Restaumatic.Analytics.Types.ItemList/index.js";
import * as Restaumatic$dCart$dCart from "../Restaumatic.Cart.Cart/index.js";
import * as Restaumatic$dCart$dDebug from "../Restaumatic.Cart.Debug/index.js";
import * as Restaumatic$dCart$dProductKey from "../Restaumatic.Cart.ProductKey/index.js";
import * as Restaumatic$dCart$dState$dState from "../Restaumatic.Cart.State.State/index.js";
import * as Restaumatic$dCart$dStorage from "../Restaumatic.Cart.Storage/index.js";
import * as Restaumatic$dI18n from "../Restaumatic.I18n/index.js";
import * as Restaumatic$dI18n$dTranslationKeys from "../Restaumatic.I18n.TranslationKeys/index.js";
import * as Restaumatic$dMenu$dDecode from "../Restaumatic.Menu.Decode/index.js";
import * as Restaumatic$dMenu$dFilterPromotions from "../Restaumatic.Menu.FilterPromotions/index.js";
import * as Restaumatic$dMenu$dV2$dEnv from "../Restaumatic.Menu.V2.Env/index.js";
import * as Restaumatic$dMenu$dV2$dProductKey from "../Restaumatic.Menu.V2.ProductKey/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dCartToOrder from "../Restaumatic.Menu.V2.Types.CartToOrder/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dMenuConsumer from "../Restaumatic.Menu.V2.Types.MenuConsumer/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dOrderOrigin from "../Restaumatic.Menu.V2.Types.OrderOrigin/index.js";
import * as Restaumatic$dProgress from "../Restaumatic.Progress/index.js";
import * as Restaumatic$dPromotionsEngine$dCart$dCartParams from "../Restaumatic.PromotionsEngine.Cart.CartParams/index.js";
import * as Restaumatic$dRestaurants$dTypes$dOrderingAvailability from "../Restaumatic.Restaurants.Types.OrderingAvailability/index.js";
import * as Restaumatic$dServices$dDelivery$dBackend from "../Restaumatic.Services.Delivery.Backend/index.js";
import * as Restaumatic$dServices$dGeocoding$dCached from "../Restaumatic.Services.Geocoding.Cached/index.js";
import * as Restaumatic$dServices$dGeocoding$dHiggs from "../Restaumatic.Services.Geocoding.Higgs/index.js";
import * as Restaumatic$dServices$dPromotions from "../Restaumatic.Services.Promotions/index.js";
import * as Restaumatic$dServices$dPromotions$dBackend from "../Restaumatic.Services.Promotions.Backend/index.js";
import * as Restaumatic$dServices$dStorage$dLocalStorageNoFallback from "../Restaumatic.Services.Storage.LocalStorageNoFallback/index.js";
import * as Restaumatic$dServices$dStorage$dLocalStorageWithFallback from "../Restaumatic.Services.Storage.LocalStorageWithFallback/index.js";
import * as Restaumatic$dServices$dStorage$dSessionStorageWithFallback from "../Restaumatic.Services.Storage.SessionStorageWithFallback/index.js";
import * as Restaumatic$dSite$dComponents$dCart$dIntegration$dCommon from "../Restaumatic.Site.Components.Cart.Integration.Common/index.js";
import * as Restaumatic$dSite$dComponents$dCart$dIntegration$dMenuV2 from "../Restaumatic.Site.Components.Cart.Integration.MenuV2/index.js";
import * as Restaumatic$dSite$dComponents$dCart$dIntegration$dRestaurantData from "../Restaumatic.Site.Components.Cart.Integration.RestaurantData/index.js";
import * as Restaumatic$dSite$dComponents$dCart$dTypes from "../Restaumatic.Site.Components.Cart.Types/index.js";
import * as Restaumatic$dSite$dComponents$dCart$dWidget from "../Restaumatic.Site.Components.Cart.Widget/index.js";
import * as Restaumatic$dSite$dComponents$dCreator from "../Restaumatic.Site.Components.Creator/index.js";
import * as Restaumatic$dSite$dComponents$dQrWaiter from "../Restaumatic.Site.Components.QrWaiter/index.js";
import * as Restaumatic$dSite$dModals from "../Restaumatic.Site.Modals/index.js";
import * as Restaumatic$dSite$dRoutes from "../Restaumatic.Site.Routes/index.js";
import * as Restaumatic$dSite$dTranslations$dKeys from "../Restaumatic.Site.Translations.Keys/index.js";
import * as Specular$dCallback from "../Specular.Callback/index.js";
import * as Specular$dDom$dBuilder from "../Specular.Dom.Builder/index.js";
import * as Specular$dDom$dWidget from "../Specular.Dom.Widget/index.js";
import * as Specular$dExtra$dSwitch from "../Specular.Extra.Switch/index.js";
import * as Specular$dFRP$dAsync from "../Specular.FRP.Async/index.js";
import * as Specular$dFRP$dBase from "../Specular.FRP.Base/index.js";
import * as Specular$dInternal$dIncremental from "../Specular.Internal.Incremental/index.js";
import * as Specular$dInternal$dIncremental$dNode from "../Specular.Internal.Incremental.Node/index.js";
import * as Specular$dInternal$dRIO from "../Specular.Internal.RIO/index.js";
import * as Specular$dProfiling from "../Specular.Profiling/index.js";
import * as Specular$dRef from "../Specular.Ref/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Utils$dWindow from "../Utils.Window/index.js";
import * as Web$dHTML from "../Web.HTML/index.js";
import * as Web$dHTML$dWindow from "../Web.HTML.Window/index.js";
const unsafeDecode = dictDecode => name => f => Data$dEither$dExtra.unsafeFromRight(Data$dList$dTypes.showNonEmptyList(Foreign.showForeignError))(name + "\nSource: " + Foreign$dInternal$dStringify.unsafeStringify(f) + "\n")(dictDecode.decode(f));
const getOrderingHour = v => {
  if (v.tag === "OrderingPossible") { return v._1.nextAvailableThatDay; }
  if (v.tag === "OrderingImpossible") { return Data$dMaybe.Nothing; }
  $runtime.fail();
};
const decodeMenu = (menuConsumer, rawMenu) => {
  const a$p = Effect$dNow.now();
  const a$p$1 = Data$dEither$dExtra.unsafeFromRight(Data$dList$dTypes.showNonEmptyList(Foreign.showForeignError))("menu")(Restaumatic$dMenu$dDecode.decodeMenu(rawMenu))();
  return Restaumatic$dMenu$dFilterPromotions.filterPromotions(Data$dDateTime$dInstant.toDateTime(a$p))(Data$dFoldable.foldlArray(m => a => Data$dMap$dInternal.insert(Restaumatic$dMenu$dV2$dTypes$dMenuConsumer.ordMenuConsumer)(a)()(m))(Data$dMap$dInternal.Leaf)([
    Restaumatic$dMenu$dV2$dTypes$dMenuConsumer.unscrambleDecodeMenuConsumer.unsafeDecode(menuConsumer)
  ]))(a$p$1);
};
const decodeAddProduct = x => ({old: x.old, new: x.new, quantity: 1, list: Data$dMaybe.$Maybe("Just", Restaumatic$dAnalytics$dTypes$dItemList.Menu)});
const createCartProductKeyFromUrl = params => catalogue => {
  const catalogueMemo = {catalogue, parametersMemo: {value: Data$dMap$dInternal.Leaf}};
  const $0 = Data$dTraversable.traversableArray.traverse(Data$dMaybe.applicativeMaybe)(str => {
    if (Data$dUUID.isValidUUID(str)) {
      const $0 = Data$dMap$dInternal.lookup(Data$dOrd.ordString)(str)(Data$dRecord.unsafeGet("products")(catalogue));
      if ($0.tag === "Just") { return Data$dMaybe.$Maybe("Just", Data$dTuple.$Tuple(str, $0._1)); }
      if ($0.tag === "Nothing") { return Data$dMaybe.Nothing; }
      $runtime.fail();
    }
    return Data$dMaybe.Nothing;
  })(Data$dString$dCommon.split("/")(params));
  if ($0.tag === "Just") {
    if ($0._1.length > 0) { return Data$dMaybe.$Maybe("Just", Restaumatic$dMenu$dV2$dProductKey.mkProductCreatorKey(catalogueMemo)($0._1)(Data$dMap$dInternal.Leaf)); }
    return Data$dMaybe.Nothing;
  }
  if ($0.tag === "Nothing") { return Data$dMaybe.Nothing; }
  $runtime.fail();
};
const decodeCartProductKeyFromUrl = (params, catalogue) => {
  const $0 = createCartProductKeyFromUrl(params)(catalogue);
  if ($0.tag === "Just") { return Data$dNullable.notNull(Restaumatic$dMenu$dV2$dTypes$dCartToOrder.encodeCartProductKey.encode($0._1)); }
  return Data$dNullable.null;
};
const runCart = options => Specular$dProfiling.measure(Effect$dClass.monadEffectEffect)("runCart")((() => {
  const $0 = Data$dEither$dExtra.unsafeFromRight(Data$dList$dTypes.showNonEmptyList(Foreign.showForeignError))("OrderingAvailability")(Restaumatic$dRestaurants$dTypes$dOrderingAvailability.decodeOrderingAvailability.decode(options.orderingAvailability));
  return () => {
    const v = $0();
    const locale = Restaumatic$dI18n.getGlobalLocale(Effect$dClass.monadEffectEffect)();
    const a$p = Effect$dNow.now();
    const now = Data$dDateTime$dInstant.toDateTime(a$p);
    const menu = options.menu;
    const restaurantData = Data$dEither$dExtra.unsafeFromRight(Data$dList$dTypes.showNonEmptyList(Foreign.showForeignError))("restaurant data")(Restaumatic$dSite$dComponents$dCart$dIntegration$dRestaurantData.decodeRestaurantData(options.restaurant))();
    const v1 = Foreign$dGeneric$dClass.decodeWithOptionsRecord()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
      reflectSymbol: () => "menu_split_pizza_image"
    })({decodeWithOptions: v$1 => Foreign$dNullOrUndefined.readNullOrUndefined(Foreign.readString(Data$dIdentity.monadIdentity))})())({
      reflectSymbol: () => "menu_group_pizza_pie_choice_classes"
    })({decodeWithOptions: v$1 => Foreign$dNullOrUndefined.readNullOrUndefined(Foreign.readString(Data$dIdentity.monadIdentity))})())({reflectSymbol: () => "menu_creator_image"})({
      decodeWithOptions: v$1 => Foreign$dNullOrUndefined.readNullOrUndefined(Foreign.readString(Data$dIdentity.monadIdentity))
    })())({reflectSymbol: () => "dish_image_style"})({decodeWithOptions: v$1 => Foreign$dNullOrUndefined.readNullOrUndefined(Foreign.readString(Data$dIdentity.monadIdentity))})())({
      reflectSymbol: () => "cart_modal_image"
    })({decodeWithOptions: v$1 => Foreign$dNullOrUndefined.readNullOrUndefined(Foreign.readString(Data$dIdentity.monadIdentity))})())({reflectSymbol: () => "cart_dish_images"})({
      decodeWithOptions: v$1 => Foreign$dNullOrUndefined.readNullOrUndefined(Foreign.readString(Data$dIdentity.monadIdentity))
    })()).decodeWithOptions(Foreign$dGeneric$dClass.defaultOptions)(options.themeSettings);
    const themeSettings = (() => {
      if (v1.tag === "Left") {
        Raven.captureMessage(Data$dList$dTypes.showNonEmptyList(Foreign.showForeignError).show(v1._1))({})();
        return Restaumatic$dSite$dComponents$dCart$dTypes.emptyThemeSettings;
      }
      if (v1.tag === "Right") {
        return {
          cartDishImages: v1._1.cart_dish_images,
          dishImageStyle: v1._1.dish_image_style,
          cartModalImage: v1._1.cart_modal_image,
          menuSplitPizzaImage: v1._1.menu_split_pizza_image,
          menuCreatorImage: v1._1.menu_creator_image,
          menuGroupPizzaPieChoiceClasses: v1._1.menu_group_pizza_pie_choice_classes
        };
      }
      $runtime.fail();
    })();
    const showCart = Specular$dFRP$dBase.newEvent(Effect$dClass.monadEffectEffect)();
    const addProduct = Specular$dFRP$dBase.newEvent(Effect$dClass.monadEffectEffect)();
    const selectPromotionById = Specular$dFRP$dBase.newEvent(Effect$dClass.monadEffectEffect)();
    const submit = Specular$dFRP$dBase.newEvent(Effect$dClass.monadEffectEffect)();
    const addItemCb = Specular$dCallback.newCallback(Effect$dClass.monadEffectEffect)();
    const addOrReplaceItem = Specular$dFRP$dBase.leftmost([Specular$dFRP$dBase.functorEvent.map(decodeAddProduct)(addProduct.event), addItemCb.event]);
    const a$p$1 = Specular$dDom$dWidget.runWidgetInNode(options.container)((() => {
      const $1 = Data$dTime$dLocal.utcToLocalDateTime(now)(options.menu.timeZone);
      const localNowD = (() => {
        const n = Specular$dInternal$dIncremental.constant($1);
        Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
        return n;
      })();
      return Specular$dInternal$dRIO.bindImpl(Specular$dRef.new(Specular$dInternal$dRIO.monadEffectRIO)(Data$dMaybe.Nothing))(fulfillmentMethodRef => Specular$dInternal$dRIO.bindImpl(Restaumatic$dSite$dComponents$dQrWaiter.isDineInOrder(Control$dMonad$dReader$dTrans.monadReaderReaderT(Specular$dInternal$dRIO.monadRIO))(Control$dMonad$dReader$dTrans.monadEffectReader(Specular$dInternal$dRIO.monadEffectRIO))({
        sessionStorage: Restaumatic$dServices$dStorage$dSessionStorageWithFallback.sessionStorageWithFallback
      }))(isQrWaiterOrder => {
        const menuEnv = Restaumatic$dMenu$dV2$dEnv.menuEnv(Data$dRecord.unsafeGet("catalogue")(options.menu))(locale)(localNowD)(fulfillmentMethodRef._1)((() => {
          const n = Specular$dInternal$dIncremental.constant(Data$dMaybe.Nothing);
          Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
          return n;
        })())((() => {
          const $2 = isQrWaiterOrder ? Restaumatic$dMenu$dV2$dTypes$dOrderOrigin.Bar : Restaumatic$dMenu$dV2$dTypes$dOrderOrigin.Online;
          return (() => {
            const n = Specular$dInternal$dIncremental.constant($2);
            Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
            return n;
          })();
        })());
        const menuConsumer = isQrWaiterOrder ? Restaumatic$dMenu$dV2$dTypes$dMenuConsumer.QrWaiter : Restaumatic$dMenu$dV2$dTypes$dMenuConsumer.Site;
        const consumers$p = Data$dFoldable.foldlArray(m => a => Data$dMap$dInternal.insert(Restaumatic$dMenu$dV2$dTypes$dMenuConsumer.ordMenuConsumer)(a)()(m))(Data$dMap$dInternal.Leaf)([
          menuConsumer
        ]);
        return Specular$dInternal$dRIO.bindImpl(Specular$dFRP$dBase.newEvent(Specular$dInternal$dRIO.monadEffectRIO))(setOrderingPossible => Specular$dInternal$dRIO.bindImpl(Specular$dFRP$dBase.foldDyn({
          MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO,
          MonadCleanup1: () => Specular$dDom$dBuilder.monadCleanupBuilder
        })(x => v$1 => x)(true)(setOrderingPossible.event))(orderingPossible => Specular$dInternal$dRIO.bindImpl(Restaumatic$dCart$dStorage.loadCartState(Restaumatic$dServices$dStorage$dLocalStorageWithFallback.localStorageWithFallback))(cartState => Specular$dInternal$dRIO.bindImpl(Specular$dFRP$dBase.readDynamic(Specular$dInternal$dRIO.monadEffectRIO)(menuEnv))(initialMenuEnv => Specular$dInternal$dRIO.bindImpl((() => {
          if (cartState.tag === "Nothing") {
            return Specular$dInternal$dRIO.pureImpl((() => {
              const n = Specular$dInternal$dIncremental.constant(Data$dMaybe.$Maybe("Just", Data$dTuple.$Tuple(Restaumatic$dCart$dCart.empty, menu)));
              Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
              return n;
            })());
          }
          if (cartState.tag === "Just") {
            const $2 = cartState._1;
            return Specular$dInternal$dRIO.bindImpl((() => {
              if ($2.couponCode.tag === "Nothing") {
                return Specular$dInternal$dRIO.pureImpl((() => {
                  const n = Specular$dInternal$dIncremental.constant(Data$dMaybe.$Maybe("Just", menu));
                  Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
                  return n;
                })());
              }
              if ($2.couponCode.tag === "Just") {
                return Specular$dInternal$dRIO.bindImpl((() => {
                  const $3 = Restaumatic$dServices$dPromotions.getActivePromotionsAndDecode(restaurantData.id)(menuConsumer)([$2.couponCode._1])(Restaumatic$dServices$dPromotions$dBackend.promotionsBackend);
                  return Specular$dFRP$dAsync.asyncRequestMaybe(Specular$dInternal$dRIO.monadEffectRIO)({
                    MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO,
                    MonadCleanup1: () => Specular$dDom$dBuilder.monadCleanupBuilder
                  })(Specular$dFRP$dBase.functorDynamic.map(Data$dMaybe.Just)((() => {
                    const n = Specular$dInternal$dIncremental.constant($3);
                    Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
                    return n;
                  })()));
                })())(v2 => Specular$dInternal$dRIO.pureImpl(Specular$dFRP$dBase.functorDynamic.map(v3 => {
                  if (v3.tag === "Loaded") {
                    if (v3._1.tag === "Promotions") {
                      return Data$dMaybe.$Maybe(
                        "Just",
                        Restaumatic$dMenu$dFilterPromotions.filterPromotions(now)(consumers$p)({
                          promotions: v3._1._1.promotions,
                          timeZone: menu.timeZone,
                          enableCoupons: menu.enableCoupons,
                          enableFod: menu.enableFod,
                          enableMarketingConsents: menu.enableMarketingConsents,
                          catalogue: menu.catalogue,
                          imagePrefix: menu.imagePrefix
                        })
                      );
                    }
                    return Data$dMaybe.$Maybe("Just", menu);
                  }
                  return Data$dMaybe.Nothing;
                })(v2)));
              }
              $runtime.fail();
            })())(menuDyn => Specular$dInternal$dRIO.pureImpl(Specular$dFRP$dBase.functorDynamic.map(v1$1 => {
              if (v1$1.tag === "Just") {
                return Data$dMaybe.$Maybe(
                  "Just",
                  Data$dTuple.$Tuple(
                    Restaumatic$dCart$dState$dState.restoreWithAssignmentMode(Restaumatic$dPromotionsEngine$dCart$dCartParams.AutoAssign)(v1$1._1)(initialMenuEnv)($2),
                    v1$1._1
                  )
                );
              }
              return Data$dMaybe.Nothing;
            })(menuDyn)));
          }
          $runtime.fail();
        })())(v1$1 => Specular$dInternal$dRIO.bindImpl(Specular$dExtra$dSwitch.dynamicSwitch({
          switch: Specular$dExtra$dSwitch.switchRecordCons({reflectSymbol: () => "canOrder"})()()(Specular$dExtra$dSwitch.switchDynamic)(Specular$dExtra$dSwitch.switchRecordCons({
            reflectSymbol: () => "cart"
          })()()(Specular$dExtra$dSwitch.switchDynamic)(Specular$dExtra$dSwitch.switchRecordCons({reflectSymbol: () => "deliveryMethod"})()()(Specular$dExtra$dSwitch.switchDynamic)(Specular$dExtra$dSwitch.switchRecordCons({
            reflectSymbol: () => "grandTotal"
          })()()(Specular$dExtra$dSwitch.switchDynamic)(Specular$dExtra$dSwitch.switchRecordCons({reflectSymbol: () => "itemCount"})()()(Specular$dExtra$dSwitch.switchDynamic)(Specular$dExtra$dSwitch.switchRecordCons({
            reflectSymbol: () => "submit"
          })()()(Specular$dExtra$dSwitch.switchEvent)({switchRecord: v$1 => v1$2 => ({})})())())())())())().switchRecord(Type$dProxy.Proxy)
        })(Specular$dDom$dBuilder.monadReplaceBuilder)({MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO, MonadCleanup1: () => Specular$dDom$dBuilder.monadCleanupBuilder})(Specular$dFRP$dBase.functorDynamic.map(v2 => {
          if (v2.tag === "Just") {
            return Specular$dDom$dBuilder.local(v3 => (
              {
                geocoding: Restaumatic$dServices$dGeocoding$dCached.cachedGeocoding({
                  storage: Restaumatic$dServices$dStorage$dLocalStorageNoFallback.localStorageNoFallback,
                  key: "locationCache"
                })({geocodeAddress: Restaumatic$dServices$dGeocoding$dHiggs.geocodeAddress(Data$dMaybe.Nothing)(Data$dMaybe.$Maybe("Just", restaurantData.id))(true)}),
                storage: Restaumatic$dServices$dStorage$dLocalStorageWithFallback.localStorageWithFallback,
                sessionStorage: Restaumatic$dServices$dStorage$dSessionStorageWithFallback.sessionStorageWithFallback,
                delivery: Restaumatic$dServices$dDelivery$dBackend.deliveryBackend,
                promotionsService: Restaumatic$dServices$dPromotions$dBackend.promotionsBackend,
                restaurantId: restaurantData.id,
                menuConsumer
              }
            ))(Restaumatic$dSite$dComponents$dCart$dWidget.cartModalWidget({
              initialCart: v2._1._1,
              menu: v2._1._2,
              baseMenu: menu,
              restaurant: restaurantData,
              accountId: options.accountId,
              themeSettings,
              openingHour: (() => {
                const $2 = (() => {
                  if (v.tag === "OrderingPossible") { return v._1.nextAvailableThatDay; }
                  if (v.tag === "OrderingImpossible") { return Data$dMaybe.Nothing; }
                  $runtime.fail();
                })();
                return (() => {
                  const n = Specular$dInternal$dIncremental.constant($2);
                  Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
                  return n;
                })();
              })(),
              addOrReplaceItem,
              showCart: showCart.event,
              submit: submit.event,
              selectFirstPromotionalItem: Specular$dFRP$dBase.functorEvent.map(id => item => item.engineItem.promotion.promotionId === id)(selectPromotionById.event),
              orderingPossible,
              now,
              menuEnv,
              menuConsumer
            }));
          }
          if (v2.tag === "Nothing") { return Specular$dInternal$dRIO.pureImpl(Restaumatic$dSite$dComponents$dCart$dTypes.nullOutput); }
          $runtime.fail();
        })(v1$1)))(cart => {
          const catalogue = Data$dRecord.unsafeGet("catalogue")(options.menu);
          const addProductFromCreator = v2 => {
            const $2 = v2.mainProduct;
            const $3 = Data$dFoldable.foldrArray(x => {
              const $3 = addItemCb.callback({
                old: Data$dMaybe.Nothing,
                new: x.product.key,
                quantity: x.quantity,
                list: Data$dMaybe.$Maybe("Just", Restaumatic$dAnalytics$dTypes$dItemList.CreatorCrossSelling)
              });
              return b => () => {
                $3();
                return b();
              };
            })(() => {})(Data$dArray.reverse(v2.crossSellingProducts));
            return () => {
              $3();
              return addItemCb.callback({
                old: Data$dMaybe.Nothing,
                new: $2.product.key,
                quantity: $2.quantity,
                list: Data$dMaybe.$Maybe("Just", Restaumatic$dAnalytics$dTypes$dItemList.Menu)
              })();
            };
          };
          return Specular$dInternal$dRIO.bindImpl((() => {
            const v2 = Data$dNullable.nullable(options.openProductCard, Data$dMaybe.Nothing, Data$dMaybe.Just);
            if (v2.tag === "Just") {
              return Specular$dInternal$dRIO.pureImpl(initialProductKey => {
                const $2 = Restaumatic$dMenu$dV2$dTypes$dCartToOrder.encodeCartProductKey.encode(initialProductKey);
                return () => v2._1($2);
              });
            }
            if (v2.tag === "Nothing") {
              return Specular$dInternal$dRIO.bindImpl(Effect$dConsole.log("Initializing old product card"))(() => Specular$dInternal$dRIO.bindImpl(Restaumatic$dSite$dComponents$dCreator.init)(creator => Specular$dInternal$dRIO.pureImpl(initialProductKey => {
                const $2 = Specular$dFRP$dBase.readDynamic(Effect$dClass.monadEffectEffect)(menuEnv);
                return () => {
                  const menuEnv$p = $2();
                  return creator.open({
                    initialProductKey,
                    restaurantId: restaurantData.id,
                    onFinish: $3 => addProductFromCreator($3),
                    menu,
                    menuEnv: menuEnv$p,
                    menuConsumer,
                    timeZone: Data$dRecord.unsafeGet("timeZone")(options.menu)
                  })();
                };
              })));
            }
            $runtime.fail();
          })())(openProductCard => Specular$dInternal$dRIO.bindImpl(() => Restaumatic$dSite$dModals._setCreatorHandler($2 => {
            const $3 = createCartProductKeyFromUrl($2)(catalogue);
            if ($3.tag === "Nothing") { return; }
            if ($3.tag === "Just") {
              openProductCard($3._1)();
              return;
            }
            $runtime.fail();
          }))(() => Specular$dInternal$dRIO.bindImpl(Specular$dFRP$dBase.subscribeDyn_({
            MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO,
            MonadCleanup1: () => Specular$dDom$dBuilder.monadCleanupBuilder
          })(x => fulfillmentMethodRef._2(_old => x))(Specular$dFRP$dBase.functorDynamic.map(Data$dMaybe.functorMaybe.map(Restaumatic$dSite$dComponents$dCart$dIntegration$dMenuV2.toFulfillmentMethod))(cart.deliveryMethod)))(() => Specular$dInternal$dRIO.bindImpl(Specular$dProfiling.measure(Specular$dInternal$dRIO.monadEffectRIO)("MenuV2.init")(Restaumatic$dSite$dComponents$dCart$dIntegration$dMenuV2.init({
            catalogue,
            locale,
            openProductCreator: (() => {
              if (v.tag === "OrderingPossible") { return openProductCard; }
              if (v.tag === "OrderingImpossible") {
                const $2 = v._1.reason;
                return v2 => {
                  const $3 = Web$dHTML$dWindow.alert($2);
                  return () => {
                    const $4 = Web$dHTML.window();
                    return $3($4)();
                  };
                };
              }
              $runtime.fail();
            })(),
            cartProductCountFn: productKey => parameterValues => Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dSite$dComponents$dCart$dIntegration$dCommon.cartProductCount(productKey)(parameterValues))(cart.cart),
            tz: Data$dRecord.unsafeGet("timeZone")(options.menu),
            menuEnv
          })))(() => Specular$dInternal$dRIO.bindImpl(Specular$dFRP$dBase.subscribeNode(Specular$dInternal$dRIO.monadEffectRIO)(Specular$dDom$dBuilder.monadCleanupBuilder)(x => Restaumatic$dCart$dStorage.storeCartState(Restaumatic$dServices$dStorage$dLocalStorageWithFallback.localStorageWithFallback)(Restaumatic$dCart$dState$dState.store(restaurantData.id)(x)))(cart.cart))(() => Specular$dInternal$dRIO.bindImpl(Specular$dFRP$dBase.foldDyn({
            MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO,
            MonadCleanup1: () => Specular$dDom$dBuilder.monadCleanupBuilder
          })(x => v$1 => x)(false)(Specular$dFRP$dBase.functorEvent.map(v$1 => true)(cart.submit)))(isSubmitting => Specular$dInternal$dRIO.bindImpl(Restaumatic$dProgress.showProgress({
            MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO,
            MonadCleanup1: () => Specular$dDom$dBuilder.monadCleanupBuilder
          })(Specular$dFRP$dBase.functorDynamic.map(b => {
            if (b) {
              return Data$dMaybe.$Maybe(
                "Just",
                Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.restaurants.widgets.cart.loading_text), {})
              );
            }
            return Data$dMaybe.Nothing;
          })(isSubmitting)))(() => Specular$dInternal$dRIO.bindImpl(Specular$dFRP$dBase.subscribeNode(Specular$dInternal$dRIO.monadEffectRIO)(Specular$dDom$dBuilder.monadCleanupBuilder)(cartValue => {
            const $2 = Restaumatic$dCart$dStorage.storeCartState(Restaumatic$dServices$dStorage$dLocalStorageWithFallback.localStorageWithFallback)(Restaumatic$dCart$dState$dState.store(restaurantData.id)(cartValue));
            return () => {
              $2();
              const p = Restaumatic$dSite$dRoutes.checkoutPath();
              return Utils$dWindow.setLocation(p + "/" + Data$dShow.showIntImpl(restaurantData.id))();
            };
          })(Specular$dFRP$dBase.sampleAt(Specular$dFRP$dBase.functorEvent.map(v$1 => x => x)(cart.submit))(cart.cart)))(() => Specular$dInternal$dRIO.pureImpl({
            showCart: showCart.fire(),
            addProduct: (() => {
              const $2 = unsafeDecode({
                decode: Foreign$dGeneric$dClass.decodeWithOptionsRecord()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
                  reflectSymbol: () => "old"
                })({decodeWithOptions: v$1 => Foreign$dNullOrUndefined.readNullOrUndefined(Restaumatic$dCart$dProductKey.decodeProductKey.decode)})())({reflectSymbol: () => "new"})({
                  decodeWithOptions: v$1 => Restaumatic$dCart$dProductKey.decodeProductKey.decode
                })()).decodeWithOptions(Foreign$dGeneric$dClass.defaultOptions)
              })("ProductKey");
              return a => {
                const $3 = $2(a);
                return () => {
                  const $4 = $3();
                  return addProduct.fire($4)();
                };
              };
            })(),
            selectPromotionById: selectPromotionById.fire,
            submit: submit.fire(),
            itemCount: cart.itemCount,
            canOrder: cart.canOrder,
            grandTotal: Specular$dFRP$dBase.functorDynamic.map(Data$dMoney$dRounded.toNumber)(cart.grandTotal),
            setOrderingPossible: f => setOrderingPossible.fire((() => {
              const v2 = Foreign.unsafeReadTagged(Data$dIdentity.monadIdentity)("Boolean")(f);
              if (v2.tag === "Left") { return true; }
              if (v2.tag === "Right") { return v2._1; }
              $runtime.fail();
            })()),
            dumpState: (() => {
              const $2 = Specular$dFRP$dBase.readDynamic(Effect$dClass.monadEffectEffect)(cart.cart);
              return () => {
                const state = $2();
                return Effect$dConsole.log("Cart state:\n" + Restaumatic$dCart$dDebug.debugDescription(restaurantData.id)(state))();
              };
            })(),
            menu,
            addProductFromCreator: $2 => addProductFromCreator(Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "crossSellingProducts"})({
              unsafeDecode: Unscramble.decodeArray(Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "product"})({
                unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "key"})(Restaumatic$dCart$dProductKey.unscrambleDecodeProductKey)(Unscramble.decodeRecordCons({
                  reflectSymbol: () => "note"
                })(Unscramble.decodeMaybe(Unscramble.decodeString1))(Unscramble.decodeRecordNil)).recordInfo(Type$dProxy.Proxy))
              })(Unscramble.decodeRecordCons({reflectSymbol: () => "quantity"})(Unscramble.decodeInt1)(Unscramble.decodeRecordNil)).recordInfo(Type$dProxy.Proxy)))
            })(Unscramble.decodeRecordCons({reflectSymbol: () => "mainProduct"})({
              unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "product"})({
                unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "key"})(Restaumatic$dCart$dProductKey.unscrambleDecodeProductKey)(Unscramble.decodeRecordCons({
                  reflectSymbol: () => "note"
                })(Unscramble.decodeMaybe(Unscramble.decodeString1))(Unscramble.decodeRecordNil)).recordInfo(Type$dProxy.Proxy))
              })(Unscramble.decodeRecordCons({reflectSymbol: () => "quantity"})(Unscramble.decodeInt1)(Unscramble.decodeRecordNil)).recordInfo(Type$dProxy.Proxy))
            })(Unscramble.decodeRecordNil)).recordInfo(Type$dProxy.Proxy))($2))()
          })))))))));
        }))))));
      }));
    })())();
    return a$p$1._1;
  };
})());
export {createCartProductKeyFromUrl, decodeAddProduct, decodeCartProductKeyFromUrl, decodeMenu, getOrderingHour, runCart, unsafeDecode};
